import { AllActions } from '../actions/allActions';
import { ApiDataTypes } from '../api/apiDataTypes';
import { InternalActionTypes } from '../constants/actionTypes';
import { AllLoadedState } from '../store/appStatusState';

export function allLoadedReducer(state: AllLoadedState = {}, action: AllActions): AllLoadedState {
  switch (action.type) {
    case InternalActionTypes.AllUsersLoaded:
      return {
        ...state,
        [ApiDataTypes.Users]: true,
      };
    case InternalActionTypes.ActiveClientsLoaded:
      return {
        ...state,
        [ApiDataTypes.ActiveClients]: true,
      };
    case InternalActionTypes.ArchivedClientsLoaded:
      return {
        ...state,
        [ApiDataTypes.ArchivedClients]: true,
      };
    case InternalActionTypes.ActiveEventsLoaded:
      return {
        ...state,
        [ApiDataTypes.ActiveEvents]: true,
      };
    case InternalActionTypes.ArchivedEventsLoaded:
      return {
        ...state,
        [ApiDataTypes.ArchivedEvents]: true,
      };
    case InternalActionTypes.AllShopsLoaded:
      return {
        ...state,
        [ApiDataTypes.Shops]: true,
      };
    case InternalActionTypes.DefaultClipConfigurationLoaded:
      return {
        ...state,
        [ApiDataTypes.DefaultClipConfiguration]: true,
      };
    default:
      return state;
  }
}
